import { ModuleWithProviders, NgModule } from '@angular/core';

import { TrackerService } from '@services/tracker.service';
import { PipelineToken } from './contracts/pipeline-token';
import { IScheduler } from './contracts/scheduler/scheduler';
import { SyncToken } from './contracts/sync-token';
import { ISyncElement } from './contracts/sync/sync-element';
import { ISyncRegistry } from './contracts/sync/sync-registry';
import { SyncTrigger } from './scheduler/sync-trigger';
import { PlatformSyncDetector } from './start/platform-sync-detector';
import { ServerConnector } from './start/server-connector';
import { SyncRegistry } from './start/sync-registry';
import { CommandQueueRunner } from './sync/command-queue-runner';
import { DatabaseCreator } from './sync/database-creator';
import { FtsIndexFinalizer } from './sync/fts-index-finalizer';
import { IndexRebuilder } from './sync/index-rebuilder';
import { MaintenanceSynchroniser } from './sync/maintenance-synchronizer';
import { MaintenanceWatchStarter } from './sync/maintenance-watch-starter';
import { ProduktlyInitializer } from './sync/produktly-initializer';
import { ShutdownInfoListener } from './sync/shutdown-info-listener';
import { SyncIndicatorCloser } from './sync/sync-indicator-closer';
import { SyncIndicatorOpener } from './sync/sync-indicator-opener';
import { SyncIndicatorPreCloser } from './sync/sync-indicator-pre-closer';
import { SyncOrderToken } from './sync/sync-order';
import { SyncStarter } from './sync/sync-starter';
import { TokenHandler } from './sync/token-handler';
import { WebSyncStarter } from './sync/web-sync-starter';

let syncRegistry: ISyncRegistry = null;

export function syncRegistryFactory(
  syncScheduler: IScheduler,
  syncElements: ISyncElement[],
  syncOrders: string[],
  trackerService: TrackerService
) {
  if (syncRegistry) {
    return syncRegistry;
  }

  syncRegistry = new SyncRegistry(syncScheduler, syncElements, syncOrders, trackerService);

  return syncRegistry;
}

@NgModule({ providers: [] })
export class PipelineModule {
  static forRoot(): ModuleWithProviders<PipelineModule> {
    return {
      ngModule: PipelineModule,
      providers: [
        { provide: PipelineToken, useClass: ServerConnector, multi: true },
        { provide: PipelineToken, useClass: PlatformSyncDetector, multi: true },
        {
          provide: PipelineToken,
          useFactory: syncRegistryFactory,
          deps: [SyncTrigger, SyncToken, SyncOrderToken, TrackerService],
          multi: true,
        },
        { provide: SyncToken, useClass: CommandQueueRunner, multi: true },
        { provide: SyncToken, useClass: MaintenanceSynchroniser, multi: true },
        { provide: SyncToken, useClass: SyncIndicatorPreCloser, multi: true },
        { provide: SyncToken, useClass: SyncIndicatorOpener, multi: true },
        { provide: SyncToken, useClass: DatabaseCreator, multi: true },
        { provide: SyncToken, useClass: IndexRebuilder, multi: true },
        { provide: SyncToken, useClass: FtsIndexFinalizer, multi: true },
        { provide: SyncToken, useClass: SyncIndicatorCloser, multi: true },
        { provide: SyncToken, useClass: SyncStarter, multi: true },
        { provide: SyncToken, useClass: WebSyncStarter, multi: true },
        { provide: SyncToken, useClass: TokenHandler, multi: true },
        { provide: SyncToken, useClass: MaintenanceWatchStarter, multi: true },
        { provide: SyncToken, useClass: ShutdownInfoListener, multi: true },
        { provide: SyncToken, useClass: ProduktlyInitializer, multi: true },
        {
          provide: SyncRegistry,
          useFactory: syncRegistryFactory,
          deps: [SyncTrigger, SyncToken, SyncOrderToken, TrackerService],
        },
      ],
    };
  }

  static forChild(): ModuleWithProviders<PipelineModule> {
    return { ngModule: PipelineModule };
  }
}
